import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useUserService } from "../../services/user.service";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthData } from "../../store/authSlice";
import { clearAllUserData } from "../../store/userSlice";
import { toast } from "react-toastify";

function ConfirmDeleteProfile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { deleteAccount } = useUserService();
  const { userId } = useSelector((state) => state.auth || {});

  const [checked, setChecked] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCheck = (id) => {
    setChecked((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const disabled = checked.length === 0 || isDeleting;

  console.log("checked.length", checked.length);
  

  const options = [
    { id: 1, label: "Не могу найти подходящего человека" },
    { id: 2, label: "Уже нашёл(ла), что искал(а)" },
    { id: 3, label: "Хочу взять паузу" },
    { id: 4, label: "Непонятно как пользоваться приложением" },
    { id: 5, label: "Слишком много рекламы" },
    { id: 6, label: "Перехожу в другое приложение" },
    { id: 7, label: "Другое" },
  ];

  const handleDeleteAccount = async () => {
    if (isDeleting) return;

    setIsDeleting(true);
    try {
      const reasons = checked
        .map((id) => {
          const option = options.find((opt) => opt.id === id);
          return option ? option.label : "";
        })
        .filter(Boolean);

      const reasonText = reasons.join(", ");

      await deleteAccount(reasonText);

      // Очищаем все данные пользователя из Redux
      dispatch(clearAllUserData());
      // Выходим из аккаунта и перенаправляем на главную
      dispatch(clearAuthData());
      // Дополнительно очищаем ключи в localStorage, связанные с инструкцией и фильтрами
      try {
        if (userId) {
          localStorage.removeItem(`appFirstLaunch_${userId}`);
        }
        localStorage.removeItem("appFirstLaunch");
        localStorage.removeItem("firstVisit3");
        localStorage.removeItem("userFilters");
        // authState/auth_token обычно очищаются by clearAuthData, но удалим на всякий случай
        localStorage.removeItem("authState");
        localStorage.removeItem("auth_token");
        console.log(
          "💾 LocalStorage: instruction and related keys cleared after account deletion"
        );
      } catch (e) {
        console.warn("Failed to clear some localStorage keys:", e);
      }
      navigate("/", { replace: true });

      // Показываем сообщение об успешном удалении
      toast.success("Аккаунт успешно удален");

      // Полная перезагрузка приложения: сбрасывает счётчики лайков в нижней
      // навигации и остальные in-memory состояния (NotificationContext и т.д.),
      // которые иначе пережили бы in-app навигацию и показали старые данные
      setTimeout(() => window.location.replace("/"), 1000);
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error("Произошла ошибка при удалении аккаунта. Попробуйте еще раз.");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="w-[100vw] h-[100%] flex flex-col items-center justify-start font-raleway overflow-scroll">
 
      <div className="w-[343px] text-[20px] text-white">
        <p className="pt-[26px] pb-[15px]">
          Укажите, пожалуйста, почему вы решили перестать пользоваться нашим
          приложением?
        </p>
        {options.map((option) => (
          <label
            key={option.id}
            className="flex items-center gap-[10px] pt-[5px] pb-[5px] cursor-pointer"
          >
            <input
              type="checkbox"
              checked={checked.includes(option.id)}
              onChange={() => handleCheck(option.id)}
              className="hidden"
            />
            <div
              className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all
              ${
                checked.includes(option.id)
                  ? "bg-[#A1F69E] border-[#A1F69E]"
                  : "bg-white border-gray-500"
              }
            `}
            >
              {checked.includes(option.id) && (
                <svg
                  className="w-4 h-4 text-black font-bold font-raleway"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              )}
            </div>
            <span className="text-white text-[18px]">{option.label}</span>
          </label>
        ))}
      </div>

      <div className="pt-[130px] pb-[30px] flex flex-col items-center justify-center">
        <button
          className={`font-medium text-white rounded-[400px] h-[64px] w-[343px] flex items-center justify-center cursor-pointer transition-colors ${
            isDeleting ? "bg-gray-500" : "bg-[#CE5D49] hover:bg-[#b54d3a]"
          }`}
          onClick={handleDeleteAccount}
          disabled={disabled}
        >
          {isDeleting ? "Удаление..." : "Удалить аккаунт"}
        </button>
      </div>
    </div>
  );
}

export default ConfirmDeleteProfile;
